var map = {
	"./airConditioning.svg": 3101,
	"./bathroom.svg": 653,
	"./breakfast.svg": 1666,
	"./default.svg": 4198,
	"./double.svg": 7535,
	"./extra.svg": 3617,
	"./fridge.svg": 8559,
	"./kettle.svg": 3879,
	"./mountainView.svg": 8970,
	"./parking.svg": 2376,
	"./riverView.svg": 7889,
	"./shower.svg": 4004,
	"./single.svg": 4357,
	"./sofa.svg": 9454,
	"./tv.svg": 5736,
	"./wardrobe.svg": 1161,
	"./wiFi.svg": 2179
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5605;